import {createMultiPathSVG} from './TEMPLATE'

// phosphor: check
export const CheckThick_Stroke2_Corner0_Rounded = createMultiPathSVG({
  paths: [
    'M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z',
  ],
  viewBox: '0 0 256 256',
})

// phosphor: check
export const Check_Stroke2_Corner0_Rounded = createMultiPathSVG({
  paths: [
    'M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z',
  ],
  viewBox: '0 0 256 256',
})
